<form tabindex="0" [attr.aria-label]="ariaLabel">
	<mat-form-field class="no_top_spacing no_bottom_spacing" >
		<input matInput type="text" [formControl]="fcSearch" [placeholder]="placeholder">
		<mat-icon matSuffix>search</mat-icon>
	</mat-form-field>
</form>